import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../layout/AuthLayout'
import { Box, Flex, Text, Button, Pagination, Modal } from '@mantine/core' 
import classes from '../../../../assets/module-css/AdminLayout.module.css'
import { IconPlus } from '@tabler/icons-react'
import { useDispatch, useSelector } from 'react-redux'
import { updateRoute } from '../../../../store/dataRoute'
import { getAllNewsList, deleteAdminNews } from '../../../../services/news'
import LoadingData from '../../../../component/ui/LoadingData'
import NoData from '../../../../component/ui/NoData'
import TableNotification from '../../../../component/pages/Notification/TableNotification'
import FormAdjustNotification from '../../../../component/pages/Notification/FormAdjustNotification'
import { notificationError } from '../../../../component/ui/Notifications'
import { modalDeleteDataUseLoginId } from '../../../../component/ui/Prompt/modalDeleteDataUseLoginId'

const defaultParameter = {
  'page[num]': 1,
  'page[limit]': 10,
  sort: '-created_at',
  include: 'creator,receiver',
}

const labelTable = [
  {
    label: 'Title',
    width: 'auto'
  },
  {
    label: 'Image',
    width: 'auto'
  },
  {
    label: 'Description',
    width: 'auto'
  },
  {
    label: 'Info',
    width: 'auto'
  },
  {
    label: 'Date',
    width: 'auto'
  },
  {
    label: 'Created By',
    width: 'auto'
  },
  {
    label: 'Notification To',
    width: 'auto'
  },
  {
    label: 'Action',
    width: 50
  },
]


const Notifications = () => {
  const { authorization } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const [params, setParams] = useState(defaultParameter)
  const [notificationList, setNotificationList] = useState([])
  const [totalData, setTotalData] = useState(0)
  const [loading, setLoading] = useState(true)
  const [openModalForm, setOpenModalForm] = useState(false)


  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Promotions',
      route: null
    },
    {
      label: 'Notifications',
      route: null
    },
  ]

  const handleGetNotification = async () => {
    setLoading(true)
    try {
      const response = await getAllNewsList(params)
      if (response.success) {
        const dataNotification = response.data

        const pickIncludedCreator = response.included.creator || []
        const pickIncludedReceiver = response.included.receiver || []

        const countData = response.meta.pagination.total

        const getDataUser = (userId, included) => {
        let data = null
        const findUser = included[userId]
        if (findUser) {
          data = {
            id: findUser.attributes.id,
            name: findUser.attributes.name
          }
        }
        return data
      }

        const remapData = dataNotification.map((val) => {
          return {
            ...val.attributes,
            sender: val.attributes.sender !== 'system' ? getDataUser(val.attributes.sender, pickIncludedCreator) : 'system',
            recipient: getDataUser(val.attributes.recipient, pickIncludedReceiver)
          }
        })

        setNotificationList(remapData)
        setTotalData(countData)
      } else {
        setNotificationList([])
        setTotalData(0)
      }
    } catch (error) {
      setNotificationList([])
      setTotalData(1)
      const errorMessage = error.response.data.message
      notificationError('Load Data Error', `${errorMessage}`)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    handleGetNotification()
    // eslint-disable-next-line
  }, [params])

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParams((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const actions = {
    delete: (val) => {
      const userLoginId = authorization.user.id
      modalDeleteDataUseLoginId('Notification', userLoginId, val.id, val.title, deleteAdminNews, handleGetNotification)
    }
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseModalForm = () => {
    setOpenModalForm(false)
  }

  return (
    <AuthLayout>
      <Box my={20}>
        <Box>
          <Flex justify='space-between' align="center" mb={30}>
            <Text className={classes.titleLayout}>Notifications</Text>
            <Button size='xs' leftSection={<IconPlus size={14} />} onClick={() => setOpenModalForm(true)}>Add Notification</Button>
          </Flex>
        </Box>
        <Box my={30}>
          {loading ? <LoadingData /> : notificationList.length > 0 ? <TableNotification label={labelTable} data={notificationList} actionMethod={handleAction} /> : <NoData />}
        </Box>
        <Flex justify='end'>
          <Pagination size='sm' onChange={handleChangePage} value={params['page[num]']} total={totalData > 0 ? Math.ceil(totalData / params['page[limit]']) : totalData} />
        </Flex>
      </Box>
      <Modal opened={openModalForm} onClose={onCloseModalForm} centered closeOnClickOutside={false} size='lg' title={<Text fw='Bold'>Add Notification</Text>} withCloseButton={false}>
        <FormAdjustNotification onCloseForm={onCloseModalForm} reloadList={handleGetNotification} />
      </Modal>
    </AuthLayout>
  )
}

export default Notifications